import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Grid, CircularProgress, FormControl } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useMediaQuery } from '@mui/material';
import { AccountLink, SubTitle, Title } from '../common';
import KenInput from '../../../Components/KenInput';
import KenSelect from '../../../Components/KenSelect';
import KenButton from '../../../Components/KenButton';
import KenPhoneInput from '../../../Components/KenPhoneInput';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Constants/routes';
import LoginBG from '../../../Assets/Svg/login-bg.svg';
import MobileLoginBG from '../../../Assets/Svg/login-mobile-bg.svg';
import { Controller, useForm, clearErrors } from 'react-hook-form';
import validator from 'validator';
import { requestForOTP, signUp, sendOtp, requestForNewOTP } from '../api';
import { useSnackbar } from 'notistack';
import phone from 'phone';

import getValidation from '../../../Utils/Helpers/validationHelper';

const useStyles = makeStyles((theme) => ({
  customDatePicker: {
    '& .react-date-picker__calendar': {
      zIndex: 2,
    },
    '& .react-date-picker__wrapper': {
      border: 0,
      borderRadius: '4px',
      padding: '6px 16px',
      backgroundColor: '#F3F5F7',
      textAlign: 'left',
      '&:focus': {
        backgroundColor: theme.palette.KenColors.kenWhite,
      },
      '& input': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__inputGroup__divider': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__button': {
        paddingRight: 0,
      },
    },
  },

  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${LoginBG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
    },
  },
  loginContent: {
    marginTop: '20px',
    backgroundColor: 'white',
    maxHeight: '600px',
    overflowY: 'scroll',
    boxShadow:
      '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    borderRadius: '16px',
    width: '100%', // Adjusted width for better responsiveness
    maxWidth: '470px',
    padding: '25px 45px',
    [theme.breakpoints.down('md')]: {
      padding: '48px 32px', // Adjusted padding for smaller screens
      margin: '20px',
      maxWidth: '363px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '48px 32px', // Adjusted padding for smaller screens
      margin: '20px',
      maxWidth: '250px !important ',
    },
  },
  title: {
    fontWeight: '500 !important',
    margin: '0 auto 20px',
    display: 'block',
    textAlign: 'center',
    marginTop: '10px',
  },
  subTitle: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    marginBottom: '32px !important',
    margin: '0 auto 20px',
    display: 'block',
    textAlign: 'center',
    marginTop: '10px',
  },
  inputFieldLabel: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '100%',
    textTransform: 'capitalize',
    color: theme.palette.KenColors.grey2,
  },
  verify: {
    width: '40%',
    height: '40px',
    marginBottom: '40px',
    borderRadius: '12px !important',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: '#4a006a !important',
    color: 'white !important',
    fontFamily: 'SamsungSharp',
    margin: 'auto', // Horizontally center the button
  },
  signupWith: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '100%',
    color: theme.palette.KenColors.neutral100,
  },
  signupWithItem: {
    margin: '0 8px',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    boxShadow:
      '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    '& img': {
      height: '24px',
      width: '24px',
    },
  },
  phoneContainer: {
    display: 'flex',
    '& .phone-input': {
      fontFamily: 'Poppins,sans-serif',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '100%',
      color: theme.palette.KenColors.grey2,
      padding: '16px',
      order: 2,
      background: '#F3F5F7',
      border: 0,
      borderRadius: '4px',
      marginLeft: '11px',
      '&::placeholder': {
        fontSize: '16px',
        lineHeight: '100%',
        color: '#A8AFBC',
        fontFamily: 'Poppins,sans-serif',
      },
    },
    '& .phone-dropdown': {
      position: 'relative',
      order: 1,
      border: 0,
      background: '#F3F5F7',
      '&.open': {
        background: '#F3F5F7',
        '& .selected-flag': {
          background: '#F3F5F7',
        },
      },
      '& .selected-flag': {
        width: '50px',
        padding: '10px',
        '&:hover': {
          background: '#F3F5F7',
        },
      },
    },
  },
  carousel: {
    marginTop: '15%',
  },
}));

const email = (value) => {
  if (validator.isEmail(value)) {
    if (value.endsWith('.com.in')) {
      return 'Please enter valid email';
    } else if(value.endsWith('.com') || value.endsWith('.in') || value.endsWith('.net') || value.endsWith('.biz') || value.endsWith('.edu') || value.endsWith('.info') || value.endsWith('.co.in') || value.endsWith('.gov') || value.endsWith('.io') || value.endsWith('.org')) {
      return true;
    } else {
      return 'Please enter valid email';
    }
  }

  return 'Please enter valid email';
};

const phoneValidator = (value) => {
  const validPhone = phone(value);
  if (validPhone.isValid == false) {
    return 'Please enter valid Phone number';
  }

  return true;
};

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  // const [date, onDateChange] = useState(null);
  const [salutation, setSalutation] = useState(null);
  const [trainingCentre, setTrainingCentre] = useState(null);
  const [courseOptions, setCourseOptions] = useState();
  const [currentSlide, setCurrentSlide] = useState(0); // State to keep track of the current slide index
  const [showVideo, setShowVideo] = useState(false);

  const [course, setCourse] = useState();
  // const [modalStyle] = React.useState(getModalStyle);
  // const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { control, handleSubmit, setValue, trigger } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    if (trainingCentre) {
      switch (trainingCentre) {
        case 'Gautam Budh University':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'Babasaheb Bhimrao Ambedkar University':
          setCourseOptions([
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            },
            { label: 'Internet Of Things', value: 'Internet Of Things' },
          ]);
          break;
        case 'City Group of College':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            },
            { label: 'Big Data', value: 'Big Data' }
          ]);
          break;
        case 'University of Lucknow':
          setCourseOptions([
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            },
            { label: 'Internet Of Things', value: 'Internet Of Things' },
          ]);
          break;
        case 'Subhash Chandra Bose Group Of Institution':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break;
        case 'Bhavdiya Group of Institutions':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break;
        case 'Deen Dayal Upadhyay Gorakhpur University':
          setCourseOptions([
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            },
            { label: 'Internet Of Things', value: 'Internet Of Things' },
          ]);
          break;
        case 'Madan Mohan Malviya University of Technology':
          setCourseOptions([
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            },
            { label: 'Internet Of Things', value: 'Internet Of Things' },
          ]);
          break;
        case 'Sri Jayachamarajendra Polytechnic College, Banglore':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break;
        case 'Government Sri Krishnarajendra Silver Jubilee Technological Institute':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break;
        case 'DIET Anakapalli':
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break;
        case "Vignan's Institute Of Information Technology":
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break;
        case 'Visakha Womens College Viskhapatnam':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
          ]);
          break;
        case 'Prism Degree College Visakhhapatnam':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
          ]);
          break; 
        case 'Nrupathunga University, Bangalore':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break; 
        case 'DDUGKP - ITM Campus':
          setCourseOptions([
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            },
            { label: 'Internet Of Things', value: 'Internet Of Things' },
          ]);
          break; 
        case 'University of Agricultural Sciences, Bangalore':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break; 
        case 'Amruta Institute of Engineering and Management Science, Bangalore':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break; 
        case 'NIU Gautam Budh Nagar':
          setCourseOptions([
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            },
            { label: 'Internet Of Things', value: 'Internet Of Things' },
          ]);
          break;
        case 'Govt RC College of Commerce and Management, Bangalore':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence',
            }
          ]);
          break;
        case 'SKVT Government Degree college, Rajahmundry':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'Maharani Cluster University, Bangalore':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'Government Polytechnic, Warangal':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'Jawaharlal Nehru Government Polytechnic, Ramanthapur, Hyderabad':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'Shivani Degree College, Warangal':
          setCourseOptions([
            { label: 'Artificial Intelligence', value: 'Artificial Intelligence' }
          ]);
          break;
        case 'University College of Engineering and Technology for Women, Warangal':
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'Brainware University, Kolkata':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "St. Joseph's College For Women (Autonomous), Vizag":
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'MS Ramaiah College of Arts Science & Commerce, Bangalore':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'Nadimpalli Satyanarayana Raju Institute of Technology, Vizag':
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'Sri Sai Vignan Bharti degree College For Women, Secundrabad':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'Dr. Ram Manohar Lohia Awadh University':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'MVR Degree College, Visakhapatnam':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'Chaitanya Degree College For Women, Visakhapatnam':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'Engineering Institute For Junior Executives (E.I.J.E)':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'NSIC Hyderabad':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case 'Kasturba Gandhi Degree & PG College For Women, Secunderabad':
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case 'Baba Institute of Technology & Sciences, Visakhapatnam':
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Women's Polytechnic, Kolkata":
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Jnan Chandra Ghosh Polytechnic, Kolkata":
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case "DDGKP - Government Girls Polytechnic, Gorakhpur":
          setCourseOptions([
            { label: 'Internet Of Things', value: 'Internet Of Things' },
            { label: 'Coding & Programming', value: 'Coding & Programming' }
          ]);
          break;
        case "Khwaja Moinuddin Chishti Language University, Lucknow":
          setCourseOptions([
            { label: 'Internet Of Things', value: 'Internet Of Things' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Govt. PG COLLEGE, NOIDA, GAUTAM BUDDHA NAGAR":
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Acharyya Prafulla Chandra Ray Polytechnic, Kolkata":
          setCourseOptions([
            { label: 'Coding & Programming', value: 'Coding & Programming' },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Lucknow University (Old Campus)":
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Dr. Ambedkar Institute of Technology for Divyangjan (A.I.T.D.), Kanpur":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            },
            { label: 'Internet Of Things', value: 'Internet Of Things' }
          ]);
          break;
        case "JNTUH University College of Engineering Nachupally (Kondagattu)":
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "University College of Engineering Tindivanam":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "RRASE COLLEGE OF ENGINEERING":
          setCourseOptions([
            { label: 'Internet Of Things', value: 'Internet Of Things' }
          ]);
          break;
        case "Dr MGR Educational and Research Institute (Deemed to be University)":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Sree Aman Arts & Science College":
          setCourseOptions([
            {
              "label": "Big Data",
              "value": "Big Data"
            }
          ]);
          break;
        case "San International College Arts & Science":
          setCourseOptions([
            {
              "label": "Big Data",
              "value": "Big Data"
            }
          ]);
          break;
        case "SNS college of Technology, Coimbatore":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Mangayarkarasi College of Engineering, Madurai":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Manikam Ramaswami College, Madurai":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "SNS College of Technology, Coimbatore, Tamil Nadu":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "SA College of Arts and Science":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Government Arts and Science College, R K Nagar":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Government Arts and Science College, Nemmeli":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Sardar Raja College of Engineering Alangulam, Tamil Nadu":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Grace College of Engineering, Tuticorin, Tamilnadu":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Anna University, Guindy, Chennai":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "IARE, Hyderabad":
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "Mangayarkarasi college of engineering, Madurai":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            { label: 'Big Data', value: 'Big Data' }
          ]);
          break;
        case "S.A. Engineering college":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            },
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Internet Of Things', value: 'Internet Of Things' }
          ]);
          break;
        case "SRM Easwari Engineering College":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            },
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Internet Of Things', value: 'Internet Of Things' }
          ]);
          break;
        case "Global Institute of engineering and technology":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            },
            { label: 'Big Data', value: 'Big Data' },
            { label: 'Internet Of Things', value: 'Internet Of Things' }
          ]);
          break;
        case "Little Flower Polytechnic College, Porur":
          setCourseOptions([
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            }
          ]);
          break;
        case "Queen Mary's College":
          setCourseOptions([
            { label: 'Internet Of Things', value: 'Internet Of Things' },
            {
              label: 'Coding & Programming',
              value: 'Coding & Programming'
            },
            { label: 'Big Data', value: 'Big Data' }
          ]);
          break;
        case "Government Arts College for Men":
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
        case "University of Madras":
          setCourseOptions([
            {
              label: 'Artificial Intelligence',
              value: 'Artificial Intelligence'
            }
          ]);
          break;
      case "Sri Eshwar College of Engineering, Coimbatore":
        setCourseOptions([
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          },
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          }
        ]);
        break;
      case "KPR Institute of Engineering and Technology":
        setCourseOptions([
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          },
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          }
        ]);
        break;
      case "Government Polytechnic College, Sevvapet":
        setCourseOptions([
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          }
        ]);
        break;
      case "Sri Ramanas College of arts and science for Women, Chidambarapuram":
        setCourseOptions([
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          },
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          }
        ]);
        break;
      case "BHARATHI WOMEN'S COLLEGE":
        setCourseOptions([
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          },
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          }
        ]);
        break;
      case "Quaid E Millath womens govt college":
        setCourseOptions([
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          },
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          }
        ]);
        break;
      case "Mohamed Sathak A.J. College of Engineering":
        setCourseOptions([
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          },
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          },
          { label: 'Big Data', value: 'Big Data' },
          { label: 'Internet Of Things', value: 'Internet Of Things' }
        ]);
        break;
      case "Rajalakshmi Engineering College":
        setCourseOptions([
          { label: 'Internet Of Things', value: 'Internet Of Things' }
        ]);
        break;
      case "V.V.Vanniaperumal College for Women (VVV College)":
        setCourseOptions([
          {
            label: 'Coding & Programming',
            value: 'Coding & Programming'
          }
        ]);
        break;
      case "Chennai National Arts and Science College":
        setCourseOptions([
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          }
        ]);
        break;
      case "The MDT Hindu College, Pettai, Tirunelveli":
        setCourseOptions([
          { label: 'Big Data', value: 'Big Data' }
        ]);
        break;
      case "Arulmigu Kabaaleeswarar Arts - Science College":
        setCourseOptions([
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          }
        ]);
        break;
      case "Thamirabharani Engineering College, Tirunelveli":
        setCourseOptions([
          { label: 'Big Data', value: 'Big Data' },
          {
            label: 'Artificial Intelligence',
            value: 'Artificial Intelligence'
          }
        ]);
        break;
      case "Bharath Institute of Higher Education and Research":
        setCourseOptions([
          { label: 'Big Data', value: 'Big Data' }
        ]);
        break;
      case "St. Xavier's, Palayamkottai":
        setCourseOptions([
          { label: 'Big Data', value: 'Big Data' }
        ]);
        break;
      
}
    }
  }, [trainingCentre]);

  function splitName(data) {
    const lastName = data.lastName.trim();
    let firstName, lastNameSplit;

    if (lastName.includes(' ')) {
      const spaceIndex = lastName.indexOf(' ');
      firstName = lastName.substring(0, spaceIndex);
      lastNameSplit = lastName.substring(spaceIndex + 1);
    } else {
      firstName = lastName;
      lastNameSplit = '.';
    }

    console.log(firstName, lastNameSplit, "lastNameSplit", lastNameSplit, "lastNameSplit23")
    return { firstName, lastName: lastNameSplit };
  }

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let { firstName, lastName } = splitName(data);
      data.firstName = firstName
      data.lastName = lastName
      data.AccountId = "0012y00000UY32uAAD"
      // const resData = await signUp(data);
      // console.log(resData, '3der3red');
      // if (resData == undefined) {
      //   enqueueSnackbar("Email ID already exists.", { variant: 'error' });
      //   setTimeout(() => navigate(routes.login), 3000);
      // }
      // if (!resData?.success) {
      //   resData?.errorMessages?.forEach((items) => {
      //     enqueueSnackbar({ message: items?.errorMessage, variant: 'error' });
      //   });
      //   setTimeout(() => navigate(routes.login), 3000);
      // } else {
        const res = await requestForNewOTP({ id: data.email });

        navigate(routes.verifyEmail, {
          state: {
            id: res.applicantId,
            email: data.email,
            phone: data.phone,
            formId: res.applicationFormId,
            // formId: '',
            data,
          },
        });
      // TODO: Change it back to verifyLogin and id to phone
    } catch (error) {
      console.log('isnide')
      console.log(error.response, "32de");
      // return enqueueSnackbar(
      //   error && error?.response?.data
      //     ? Array.isArray(error?.response?.data?.errorMessages) &&
      //         error?.response?.data?.errorMessages[0]?.errorMessage
      //     : error?.response?.data?.errorMessage || 'Something went wrong',
      //   {
      //     variant: 'error',
      //   }
      // );
    } finally {
      setLoading(false);
    }
  };
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const trainingCentreOption = [
    {
      label: 'Gautam Budh University',
      value: 'Gautam Budh University',
    },
    {
      label: 'Babasaheb Bhimrao Ambedkar University',
      value: 'Babasaheb Bhimrao Ambedkar University',
    },
    {
      label: 'City Group of College',
      value: 'City Group of College',
    },
    {
      label: 'University of Lucknow',
      value: 'University of Lucknow',
    },
    {
      label: 'Subhash Chandra Bose Group Of Institution',
      value: 'Subhash Chandra Bose Group Of Institution',
    },
    { label: 'Bhavdiya Group of Institutions', 
      value: 'Bhavdiya Group of Institutions' 
    },
    { label: 'Deen Dayal Upadhyay Gorakhpur University', 
      value: 'Deen Dayal Upadhyay Gorakhpur University' 
    },
    {
      label: 'Madan Mohan Malviya University of Technology',
      value: 'Madan Mohan Malviya University of Technology',
    },
    {
      label: 'Sri Jayachamarajendra Polytechnic College, Banglore',
      value: 'Sri Jayachamarajendra Polytechnic College, Banglore',
    },
    {
      label: 'Government Sri Krishnarajendra Silver Jubilee Technological Institute',
      value: 'Government Sri Krishnarajendra Silver Jubilee Technological Institute',
    },
    {
      label: 'DIET Anakapalli',
      value: 'DIET Anakapalli',
    },
    {
      label: "Vignan's Institute Of Information Technology",
      value: "Vignan's Institute Of Information Technology",
    },
    {
      label: 'Visakha Womens College Viskhapatnam',
      value: 'Visakha Womens College Viskhapatnam',
    },
    {
      label: 'Prism Degree College Visakhhapatnam',
      value: 'Prism Degree College Visakhhapatnam',
    },
    {
      label: 'Nrupathunga University, Bangalore',
      value: 'Nrupathunga University, Bangalore',
    },
    {
      label: 'DDUGKP - ITM Campus',
      value: 'DDUGKP - ITM Campus',
    },
    {
      label: 'University of Agricultural Sciences, Bangalore',
      value: 'University of Agricultural Sciences, Bangalore',
    },
    {
      label: 'Amruta Institute of Engineering and Management Science, Bangalore',
      value: 'Amruta Institute of Engineering and Management Science, Bangalore'
    },
    {
      label: 'NIU Gautam Budh Nagar',
      value: 'NIU Gautam Budh Nagar'
    },
    {
      label: 'Govt RC College of Commerce and Management, Bangalore',
      value: 'Govt RC College of Commerce and Management, Bangalore'
    },
    {
      label: 'SKVT Government Degree college, Rajahmundry',
      value: 'SKVT Government Degree college, Rajahmundry'
    },
    {
      label: 'Maharani Cluster University, Bangalore',
      value: 'Maharani Cluster University, Bangalore'
    },
    {
      label: 'Government Polytechnic, Warangal',
      value: 'Government Polytechnic, Warangal'
    },
    {
      label: 'Jawaharlal Nehru Government Polytechnic, Ramanthapur, Hyderabad',
      value: 'Jawaharlal Nehru Government Polytechnic, Ramanthapur, Hyderabad'
    },
    {
      label: 'Shivani Degree College, Warangal',
      value: 'Shivani Degree College, Warangal'
    },
    {
      label: 'University College of Engineering and Technology for Women, Warangale',
      value: 'University College of Engineering and Technology for Women, Warangale'
    },
    {
      label: 'Brainware University, Kolkata',
      value: 'Brainware University, Kolkata'
    },
    {
      "label": "St. Joseph's College For Women (Autonomous), Vizag",
      "value": "St. Joseph's College For Women (Autonomous), Vizag"
    },
    {
      "label": "MS Ramaiah College of Arts Science & Commerce, Bangalore",
      "value": "MS Ramaiah College of Arts Science & Commerce, Bangalore"
    },
    {
      "label": "Nadimpalli Satyanarayana Raju Institute of Technology, Vizag",
      "value": "Nadimpalli Satyanarayana Raju Institute of Technology, Vizag"
    },
    {
      "label": "Sri Sai Vignan Bharti degree College For Women, Secundrabad",
      "value": "Sri Sai Vignan Bharti degree College For Women, Secundrabad"
    },
    {
      "label": "Dr. Ram Manohar Lohia Awadh University",
      "value": "Dr. Ram Manohar Lohia Awadh University"
    },
    {
      "label": "MVR Degree College, Visakhapatnam",
      "value": "MVR Degree College, Visakhapatnam"
    },
    {
      "label": "Chaitanya Degree College For Women, Visakhapatnam",
      "value": "Chaitanya Degree College For Women, Visakhapatnam"
    },
    {
      "label": "Engineering Institute For Junior Executives (E.I.J.E)",
      "value": "Engineering Institute For Junior Executives (E.I.J.E)"
    },
    {
      "label": "NSIC Hyderabad",
      "value": "NSIC Hyderabad"
    },
    {
      "label": "Kasturba Gandhi Degree & PG College For Women, Secunderabad",
      "value": "Kasturba Gandhi Degree & PG College For Women, Secunderabad"
    },
    {
      "label": "Baba Institute of Technology & Sciences, Visakhapatnam",
      "value": "Baba Institute of Technology & Sciences, Visakhapatnam"
    },
    {
      "label": "Women's Polytechnic, Kolkata",
      "value": "Women's Polytechnic, Kolkata"
    },
    {
      "label": "Jnan Chandra Ghosh Polytechnic, Kolkata",
      "value": "Jnan Chandra Ghosh Polytechnic, Kolkata"
    },
    {
      "label": "DDGKP - Government Girls Polytechnic, Gorakhpur",
      "value": "DDGKP - Government Girls Polytechnic, Gorakhpur"
    },
    {
      "label": "Khwaja Moinuddin Chishti Language University, Lucknow",
      "value": "Khwaja Moinuddin Chishti Language University, Lucknow"
    },
    {
      "label": "Govt. PG COLLEGE, NOIDA, GAUTAM BUDDHA NAGAR",
      "value": "Govt. PG COLLEGE, NOIDA, GAUTAM BUDDHA NAGAR"
    },
    {
      "label": "Acharyya Prafulla Chandra Ray Polytechnic, Kolkata",
      "value": "Acharyya Prafulla Chandra Ray Polytechnic, Kolkata"
    },
    {
      "label": "Lucknow University (Old Campus)",
      "value": "Lucknow University (Old Campus)"
    },
    {
      "label": "Dr. Ambedkar Institute of Technology for Divyangjan (A.I.T.D.), Kanpur",
      "value": "Dr. Ambedkar Institute of Technology for Divyangjan (A.I.T.D.), Kanpur"
    },
    {
      "label": "JNTUH University College of Engineering Nachupally (Kondagattu)",
      "value": "JNTUH University College of Engineering Nachupally (Kondagattu)"
    },
    {
      "label": "University College of Engineering Tindivanam",
      "value": "University College of Engineering Tindivanam"
    },
    {
      "label": "RRASE COLLEGE OF ENGINEERING",
      "value": "RRASE COLLEGE OF ENGINEERING"
    },
    {
      "label": "Dr MGR Educational and Research Institute (Deemed to be University)",
      "value": "Dr MGR Educational and Research Institute (Deemed to be University)"
    },
    {
      "label": "Sree Aman Arts & Science College",
      "value": "Sree Aman Arts & Science College"
    },
    {
      "label": "San International College Arts & Science",
      "value": "San International College Arts & Science"
    },
    {
      "label": "SNS college of Technology, Coimbatore",
      "value": "SNS college of Technology, Coimbatore"
    },
    {
      "label": "Mangayarkarasi College of Engineering, Madurai",
      "value": "Mangayarkarasi College of Engineering, Madurai"
    },
    {
      "label": "Manikam Ramaswami College, Madurai",
      "value": "Manikam Ramaswami College, Madurai"
    },
    {
      "label": "SNS College of Technology, Coimbatore, Tamil Nadu",
      "value": "SNS College of Technology, Coimbatore, Tamil Nadu"
    },
    {
      "label": "SA College of Arts and Science",
      "value": "SA College of Arts and Science"
    },
    {
      "label": "Government Arts and Science College, R K Nagar",
      "value": "Government Arts and Science College, R K Nagar"
    },
    {
      "label": "Government Arts and Science College, Nemmeli",
      "value": "Government Arts and Science College, Nemmeli"
    },
    {
      "label": "Sardar Raja College of Engineering Alangulam, Tamil Nadu",
      "value": "Sardar Raja College of Engineering Alangulam, Tamil Nadu"
    },
    {
      "label": "Grace College of Engineering, Tuticorin, Tamilnadu",
      "value": "Grace College of Engineering, Tuticorin, Tamilnadu"
    },
    {
      "label": "Anna University, Guindy, Chennai",
      "value": "Anna University, Guindy, Chennai"
    },
    {
      "label": "IARE, Hyderabad",
      "value": "IARE, Hyderabad"
    },
    {
      "label": "Mangayarkarasi college of engineering, Madurai",
      "value": "Mangayarkarasi college of engineering, Madurai"
    },
    {
      "label": "S.A. Engineering college",
      "value": "S.A. Engineering college"
    },
    {
      "label": "SRM Easwari Engineering College",
      "value": "SRM Easwari Engineering College"
    },
    {
      "label": "Global Institute of engineering and technology",
      "value": "Global Institute of engineering and technology"
    },
    {
      "label": "Little Flower Polytechnic College, Porur",
      "value": "Little Flower Polytechnic College, Porur"
    },
    {
      "label": "Queen Mary's College",
      "value": "Queen Mary's College"
    },
    {
      "label": "Government Arts College for Men",
      "value": "Government Arts College for Men"
    },
    {
      "label": "University of Madras",
      "value": "University of Madras"
    },
    {
      "label": "Sri Eshwar College of Engineering, Coimbatore",
      "value": "Sri Eshwar College of Engineering, Coimbatore"
    },
    {
      "label": "KPR Institute of Engineering and Technology",
      "value": "KPR Institute of Engineering and Technology"
    },
    {
      "label": "Government Polytechnic College, Sevvapet",
      "value": "Government Polytechnic College, Sevvapet"
    },
    {
      "label": "Sri Ramanas College of arts and science for Women, Chidambarapuram",
      "value": "Sri Ramanas College of arts and science for Women, Chidambarapuram"
    },
    {
      "label": "BHARATHI WOMEN'S COLLEGE",
      "value": "BHARATHI WOMEN'S COLLEGE"
    },
    {
      "label": "Quaid E Millath womens govt college",
      "value": "Quaid E Millath womens govt college"
    },
    {
      "label": "Mohamed Sathak A.J. College of Engineering",
      "value": "Mohamed Sathak A.J. College of Engineering"
    },
    {
      "label": "Rajalakshmi Engineering College",
      "value": "Rajalakshmi Engineering College"
    },
    {
      "label": "V.V.Vanniaperumal College for Women (VVV College)",
      "value": "V.V.Vanniaperumal College for Women (VVV College)"
    },
    {
      "label": "Chennai National Arts and Science College",
      "value": "Chennai National Arts and Science College"
    },
    {
      "label": "The MDT Hindu College, Pettai, Tirunelveli",
      "value": "The MDT Hindu College, Pettai, Tirunelveli"
    },
    {
      "label": "Arulmigu Kabaaleeswarar Arts - Science College",
      "value": "Arulmigu Kabaaleeswarar Arts - Science College"
    },
    {
      "label": "Thamirabharani Engineering College, Tirunelveli",
      "value": "Thamirabharani Engineering College, Tirunelveli"
    },
    {
      "label": "Bharath Institute of Higher Education and Research",
      "value": "Bharath Institute of Higher Education and Research"
    },
    {
      "label": "St. Xavier's, Palayamkottai",
      "value": "St. Xavier's, Palayamkottai"
    }
  ];

  return (
    <Grid container>
      {/* Conditionally render only on small screens */}
      {isSmallScreen && (
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '81vh',
            backgroundImage: `url(${MobileLoginBG})`,
            backgroundRepeat: 'no-repeat', // Set background image to not repeat
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box className={classes.loginContent}>
              <PerfectScrollbar>
                <Title className={classes.title} text="Get Started!" />
                <SubTitle
                  className={classes.subTitle}
                  text="Sign Up to start using this platform."
                />
                {/* <Grid container spacing={1}> */}
                {/* <Grid item xs={2}> */}
                <FormControl fullWidth style={{ marginBottom: '24px' }}>
                  <Controller
                    name="salutation"
                    control={control}
                    rules={{ 
                      required: 'This field is Required', 
                      // pattern:{
                      //   value: "",
                      //   message: "Please Input a valid Name"
                      // }
                    }}
                    render={({ field, fieldState: { error } }) => {
                      return (
                        <KenSelect
                          name="salutation"
                          required
                          select
                          label="Salutation"
                          value={salutation}
                          labelClassName={classes.inputFieldLabel}
                          options={[
                            { label: 'Mr.', value: 'Mr.' },
                            { label: 'Mrs.', value: 'Mrs.' },
                            { label: 'Ms.', value: 'Ms.' },
                          ]}
                          {...field}
                          error={error?.message}
                          onChange={(event, item, v) => {
                            setSalutation(event.target.value);
                            // clearErrors('salutation');
                            setValue('salutation', event.target.value);
                          }}
                        />
                      );
                    }}
                  />
                </FormControl>
                {/* </Grid> */}
                {/* <Grid item xs={5}> */}
                {/* <FormControl fullWidth style={{ marginBottom: '24px' }}>
                  <Controller
                    name="firstName"
                    control={control}
                    rules={{
                      required: 'This field is Required',
                      maxLength: {
                        value: 20,
                        message: 'This field cannot be more than 20 characters',
                      },
                      pattern: {
                        message: 'Please input a correct value',
                        value: getValidation('alpha'),
                      },
                    }}
                    render={({ field, fieldState: { error } }) => {
                      return (
                        <KenInput
                          required
                          name="firstName"
                          label="First Name"
                          placeholder="Enter First Name"
                          errorLabel={false}
                          labelClassName={classes.inputFieldLabel}
                          {...field}
                          error={error?.message}
                        />
                      );
                    }}
                  />
                </FormControl> */}
                {/* </Grid> */}
                {/* <FormControl fullWidth style={{ marginBottom: '24px' }}>
                      <Controller
                        name="middleName"
                        control={control}
                        render={({ field, fieldState: { error } }) => {
                          return (
                            <KenInput
                              name="middleName"
                              label="Middle Name"
                              placeholder="Enter Middle Name"
                              labelClassName={classes.inputFieldLabel}
                              errorLabel={false}
                              {...field}
                              error={error}
                            />
                          );
                        }}
                      />
                    </FormControl> */}
                {/* <Grid item xs={5}> */}
                <FormControl fullWidth style={{ marginBottom: '24px' }}>
                  <Controller
                    name="lastName"
                    control={control}
                    rules={{
                      required: 'This field is Required',
                      minLength: {
                        value: 2,
                        message: 'Please Enter valid name',
                      },
                      maxLength: {
                        value: 50,
                        message: 'This field cannot be more than 50 characters',
                      },
                      pattern: {
                        message: 'Please input a correct value',
                        value: getValidation('alpha'),
                      },
                    }}
                    render={({ field, fieldState: { error } }) => {
                      return (
                        <KenInput
                          required
                          name="lastName"
                          label="Full Name"
                          placeholder="Enter Full Name"
                          errorLabel={false}
                          labelClassName={classes.inputFieldLabel}
                          {...field}
                          error={error?.message}
                        />
                      );
                    }}
                  />
                </FormControl>
                {/* </Grid> */}
                {/* </Grid> */}
                {/* <Grid container spacing={1}> */}
                {/* <Grid item xs={6}> */}
                <FormControl fullWidth style={{ marginBottom: '24px' }}>
                  <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: 'This field is Required',
                      validate: email,
                    }}
                    render={({ field, fieldState: { error } }) => {
                      return (
                        <KenInput
                          required
                          name="email"
                          label="Email"
                          placeholder="Enter Email"
                          labelClassName={classes.inputFieldLabel}
                          errorLabel={false}
                          {...field}
                          error={error?.message}
                        />
                      );
                    }}
                  />
                </FormControl>
                {/* </Grid> */}
                {/* <Grid item xs={6}> */}
             <FormControl fullWidth style={{ marginBottom: '24px' }}>
  <Controller
    name="phone"
    control={control}
    rules={{
      required: 'This field is Required',
      validate: phoneValidator,
      maxLength: {
        value: 17,
        message: 'Please input valid phone number',
      },
    }}
    render={({ field, fieldState: { error } }) => (
      <KenPhoneInput
        name="phone"
        containerClass={classes.phoneContainer}
        inputClass={`${classes.inputFieldLabel} phone-input`}
        buttonClass="phone-dropdown"
        country="in"
        placeholder="Enter Number"
        errorLabel={false}
        
        /** VERY IMPORTANT — DO NOT SPREAD {...field} */
        value={field.value || ''} 
        error={error?.message}

        /* Sync back the final cleaned phone */
        onChange={(phone) => {
          field.onChange(phone);
          setValue("phone", phone);
          trigger("phone");
        }}
      />
    )}
  />
</FormControl>

                {/* </Grid> */}
                {/* </Grid> */}
                {/* <Grid container spacing={1}> */}
                {/* <Grid item xs={6}> */}
                <FormControl fullWidth style={{ marginBottom: '24px' }}>
                  <Controller
                    name="trainingCentre"
                    control={control}
                    rules={{ required: 'This field is Required' }}
                    render={({ field, fieldState: { error } }) => {
                      return (
                        <KenSelect
                          name="trainingCentre"
                          required
                          select
                          label="Training Centre"
                          value={trainingCentre}
                          labelClassName={classes.inputFieldLabel}
                          options={trainingCentreOption}
                          {...field}
                          error={error?.message}
                          onChange={(event, item, v) => {
                            setTrainingCentre(event.target.value);
                            setValue('trainingCentre', event.target.value);
                          }}
                        />
                      );
                    }}
                  />
                </FormControl>
                {/* </Grid> */}
                {trainingCentre ? (
                  // <Grid item xs={6}>
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="course"
                      control={control}
                      rules={{ required: 'This field is Required' }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenSelect
                            name="course"
                            required
                            select
                            label="Course"
                            value={course}
                            labelClassName={classes.inputFieldLabel}
                            options={courseOptions}
                            {...field}
                            error={error?.message}
                            onChange={(event, item, v) => {
                              setCourse(event.target.value);
                              setValue('course', event.target.value);
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                ) : (
                  // </Grid>
                  <></>
                )}

                {/* </Grid> */}
                {/* <FormControl fullWidth style={{ marginBottom: "24px" }}>
                    <Controller
                      name="salutation"
                      control={control}
                      rules={{ required: true }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenSelect
                            name="salutation"
                            required
                            select
                            label="Salutation"
                            value={salutation}
                            labelClassName={classes.inputFieldLabel}
                            options={[
                              { label: "Mr.", value: "Mr." },
                              { label: "Mrs.", value: "Mrs." },
                              { label: "Ms.", value: "Ms." }
                            ]}
                            {...field}
                            error={error?.message}
                            onChange={(event, item, v) => {
                              setSalutation(event.target.value);
                              setValue("salutation", event.target.value);
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl> */}
                <Box width="100%">
                  <KenButton
                    variant="primary"
                    buttonClass={classes.verify}
                    type="submit"
                    disabled={loading}
                  >
                    Verify
                  </KenButton>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '49%',
                        transform: 'translate(-50%, -50%)',
                      }}
                    />
                  )}
                </Box>
                <Box
                  display={'flex'}
                  justifyContent="center"
                  alignItems={'center'}
                  width="100%"
                >
                  <AccountLink
                    text="Already Have An Account?"
                    actionText={'Log In'}
                    onAction={() => navigate(routes.login)}
                  />
                </Box>
              </PerfectScrollbar>
            </Box>
          </form>
        </Grid>
      )}

      {/* Conditionally render only on screens larger than small */}
      {!isSmallScreen && (
        <Grid
          item
          xs={12} // Show on extra small screens and above
          style={{
            position: 'relative',
            minHeight: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            width: '100%',
            backgroundImage: `url("https://inazstgpfs3001.blob.core.windows.net/assets/Images/SAMSUNG/BackgroundPFS.png")`,
          }}
        >
          <Grid
            className={classes.container}
            style={{
              position: 'absolute',
              top: '50%',
              left: '80%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box className={classes.loginContent}>
                <PerfectScrollbar>
                  <Title className={classes.title} text="Get Started!" />
                  <SubTitle
                    className={classes.subTitle}
                    text="Sign Up to start using this platform."
                  />
                  {/* <Grid container spacing={1}> */}
                  {/* <Grid item xs={2}> */}
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="salutation"
                      control={control}
                      rules={{ required: 'This field is Required' }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenSelect
                            name="salutation"
                            required
                            select
                            label="Salutation"
                            value={salutation}
                            labelClassName={classes.inputFieldLabel}
                            options={[
                              { label: 'Mr.', value: 'Mr.' },
                              { label: 'Mrs.', value: 'Mrs.' },
                              { label: 'Ms.', value: 'Ms.' },
                            ]}
                            {...field}
                            error={error?.message}
                            onChange={(event, item, v) => {
                              setSalutation(event.target.value);
                              setValue('salutation', event.target.value);
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  {/* </Grid> */}
                  {/* <Grid item xs={5}> */}
                  {/* <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="firstName"
                      control={control}
                      rules={{
                        required: 'This field is Required',
                        maxLength: {
                          value: 20,
                          message:
                            'This field cannot be more than 20 characters',
                        },
                        pattern: {
                          message: 'Please input a correct value',
                          value: getValidation('alpha'),
                        },
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenInput
                            required
                            name="firstName"
                            label="First Name"
                            placeholder="Enter First Name"
                            errorLabel={false}
                            labelClassName={classes.inputFieldLabel}
                            {...field}
                            error={error?.message}
                          />
                        );
                      }}
                    />
                  </FormControl> */}
                  {/* </Grid> */}
                  {/* <FormControl fullWidth style={{ marginBottom: '24px' }}>
                      <Controller
                        name="middleName"
                        control={control}
                        render={({ field, fieldState: { error } }) => {
                          return (
                            <KenInput
                              name="middleName"
                              label="Middle Name"
                              placeholder="Enter Middle Name"
                              labelClassName={classes.inputFieldLabel}
                              errorLabel={false}
                              {...field}
                              error={error}
                            />
                          );
                        }}
                      />
                    </FormControl> */}
                  {/* <Grid item xs={5}> */}
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="lastName"
                      control={control}
                      rules={{
                        required: 'This field is Required',
                        minLength: {
                          value: 2,
                          message: 'Please Enter valid name',
                        },
                        maxLength: {
                          value: 50,
                          message:
                            'This field cannot be more than 50 characters',
                        },
                        pattern: {
                          message: 'Please input a correct value',
                          value: getValidation('alpha'),
                        },
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenInput
                            required
                            name="lastName"
                            label="Full Name"
                            placeholder="Enter Full Name"
                            errorLabel={false}
                            labelClassName={classes.inputFieldLabel}
                            {...field}
                            error={error?.message}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  {/* </Grid> */}
                  {/* </Grid> */}
                  {/* <Grid container spacing={1}> */}
                  {/* <Grid item xs={6}> */}
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: 'This field is Required',
                        validate: email,
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenInput
                            required
                            name="email"
                            label="Email"
                            placeholder="Enter Email"
                            labelClassName={classes.inputFieldLabel}
                            errorLabel={false}
                            {...field}
                            error={error?.message}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  {/* </Grid> */}
                  {/* <Grid item xs={6}> */}
                  <FormControl
                    fullWidth
                    style={{ marginBottom: '24px', alignItems: 'baseline' }}
                  >
                    <Controller
                      name="phone"
                      control={control}
                      rules={{
                        required: 'This field is Required',
                        validate: phoneValidator,
                      }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenPhoneInput
                            name="phone"
                            containerClass={classes.phoneContainer}
                            inputClass={`${classes.inputFieldLabel} phone-input`}
                            buttonClass="phone-dropdown"
                            country={'in'}
                            placeholder="Enter Number"
                            errorLabel={false}
                            {...field}
                            error={error?.message}
                            onChange={(phone) => {
                              setValue('phone', phone);
                              trigger('phone');
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  {/* </Grid> */}
                  {/* </Grid> */}
                  {/* <Grid container spacing={1}> */}
                  {/* <Grid item xs={6}> */}
                  <FormControl fullWidth style={{ marginBottom: '24px' }}>
                    <Controller
                      name="trainingCentre"
                      control={control}
                      rules={{ required: 'This field is Required' }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenSelect
                            name="trainingCentre"
                            required
                            select
                            label="Training Centre"
                            value={trainingCentre}
                            labelClassName={classes.inputFieldLabel}
                            options={trainingCentreOption}
                            {...field}
                            error={error?.message}
                            onChange={(event, item, v) => {
                              setTrainingCentre(event.target.value);
                              setValue('trainingCentre', event.target.value);
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                  {/* </Grid> */}
                  {trainingCentre ? (
                    // <Grid item xs={6}>
                    <FormControl fullWidth style={{ marginBottom: '24px' }}>
                      <Controller
                        name="course"
                        control={control}
                        rules={{ required: 'This field is Required' }}
                        render={({ field, fieldState: { error } }) => {
                          return (
                            <KenSelect
                              name="course"
                              required
                              select
                              label="Course"
                              value={course}
                              labelClassName={classes.inputFieldLabel}
                              options={courseOptions}
                              {...field}
                              error={error?.message}
                              onChange={(event, item, v) => {
                                setCourse(event.target.value);
                                setValue('course', event.target.value);
                              }}
                            />
                          );
                        }}
                      />
                    </FormControl>
                  ) : (
                    // </Grid>
                    <></>
                  )}

                  {/* </Grid> */}
                  {/* <FormControl fullWidth style={{ marginBottom: "24px" }}>
                    <Controller
                      name="salutation"
                      control={control}
                      rules={{ required: true }}
                      render={({ field, fieldState: { error } }) => {
                        return (
                          <KenSelect
                            name="salutation"
                            required
                            select
                            label="Salutation"
                            value={salutation}
                            labelClassName={classes.inputFieldLabel}
                            options={[
                              { label: "Mr.", value: "Mr." },
                              { label: "Mrs.", value: "Mrs." },
                              { label: "Ms.", value: "Ms." }
                            ]}
                            {...field}
                            error={error?.message}
                            onChange={(event, item, v) => {
                              setSalutation(event.target.value);
                              setValue("salutation", event.target.value);
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl> */}
                  <Box width="100%">
                    <KenButton
                      variant="primary"
                      buttonClass={classes.verify}
                      type="submit"
                      disabled={loading}
                    >
                      Verify
                    </KenButton>
                    {loading && (
                      <CircularProgress
                        size={24}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '49%',
                          transform: 'translate(-50%, -50%)',
                        }}
                      />
                    )}
                  </Box>
                  <Box
                    display={'flex'}
                    justifyContent="center"
                    alignItems={'center'}
                    width="100%"
                  >
                    <AccountLink
                      text="Already Have An Account?"
                      actionText={'Log In'}
                      onAction={() => navigate(routes.login)}
                    />
                  </Box>
                </PerfectScrollbar>
              </Box>
            </form>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
